import React from "react";
import { StyledCheckBadge } from "./style";
import { ValidateColorType } from "types/admin/AdminType";
import { Icon } from "components/icon/Icon";
import { ThemeColorType } from "types/common/CommonType";

interface CheckBadgeType {
  title: string;
  color?: ValidateColorType;
  textNoWrap?: boolean;
}

export function CheckBadge({
  title,
  color = "gray",
  textNoWrap = false,
}: CheckBadgeType) {
  const getIconColor = (): ThemeColorType => {
    if (color === "red") {
      return `--sys-red-1`;
    } else if (color === "blue") {
      return `--pri-blue-4`;
    } else return `--text-gray-3`;
  };
  return (
    <StyledCheckBadge $color={color} $textNoWrap={textNoWrap}>
      <Icon icon="CheckSquareBroken" size={12} stroke={getIconColor()} />
      <span>{title}</span>
    </StyledCheckBadge>
  );
}
